import Alpine from "alpinejs";
import { PasswordInputFieldData } from "./passwordInputFieldData";
import { FormData } from "./formData";
import { InputFieldData } from "./inputFieldData";
import { ResendCodeButton } from "./resendCodeButton";
import { FORM_VALIDATED } from "./consts";
import { BackButton } from "./back";

window.Alpine = Alpine;

Alpine.data(
  "PasswordFieldInputData",
  (
    showPassword = false,
    showAdditionalMessage = false,
    rules = [],
    password = "",
    failedValidationMessage = "InvalidPassword",
    passwordRequiredMessage = "InvalidPassword",
    serverMessage = ""
  ) =>
    PasswordInputFieldData({
      password,
      rules,
      showAdditionalMessage,
      showPassword,
      failedValidationMessage,
      passwordRequiredMessage,
      serverMessage,
    })
);

Alpine.data("FormData", (validated) =>
  FormData({ [FORM_VALIDATED]: validated === "Invalid" })
);

Alpine.data(
  "InputFieldData",
  (
    input = "",
    inputRefName = "input",
    serverMessage = "",
    validationMessage = ""
  ) =>
    InputFieldData({
      inputRefName,
      serverMessage,
      validationMessage,
      input,
    })
);

Alpine.data(
  "CheckboxInputFieldData",
  (
    input = false,
    inputRefName = "input",
    serverMessage = "",
    validationMessage = ""
  ) =>
    InputFieldData({
      inputRefName,
      serverMessage,
      validationMessage,
      input,
    })
);

Alpine.data(
  "ResendCodeButton",
  (successContent = "A code has been successfully sent") =>
    ResendCodeButton({
      successContent,
    })
);
Alpine.data("BackButton", () => BackButton());

Alpine.start();
